/*jshint esversion: 6 */

/*! webmd.ads */

// Dependencies:
// Ads Library used render Google Ads on WebMD and O&O

import { customEvent, getPvid, getAvid } from 'webmd-core'
import { getParam, getEnv, getSLD } from 'webmd-url'
import { getCount } from 'webmd-pim'
import debug from 'webmd-debug'
import cookie from 'webmd-cookie';
import { ua } from 'webmd-useragent';

require("webmd-ad-kibana");
require('webmd-medianet-headerbidding');
require('webmd-amazon-headerbidding');
require('webmd-medscape-exchange');
require('webmd-magnite-demand');
require('webmd-id5');
require('webmd-double-verify');
require('webmd-blockthrough');
require('webmd-id5-pp-integration');
require('webmd-transunion');
import optimera from 'webmd-optimera'

let ads;

if (typeof window !== 'undefined') {
  // High priority, sensitive and partially sensitive topics
  window.semiTransparent = [
    '1624','3634','1629','4272','1662','3557','3641','3633','1822','1823','1826','3645','1827','1831','1688','4223','4054','7000','7001','7002','7004','7005','7006','7007','7009','7010','7012','7013','7014','7015','7019','7021','7022','7023','7024','7025','7121','7122','1628','3623','1633','3607','1819','3624','3625','3610'
  ];
  // customEvent polyfill for IE
  customEvent();

  /* NOTE: developers should not directly call google code, they should only use functions in webmd.ads namespace. If
   * additional functionality is needed, it should be added to webmd.ads namespace so we can have a single interface into
   * the google code.
   */

  // Set up array of functions to run after the Google code loads.
  // google.cmd is the array of functions to run.
  // You must use google.cmd.push() to add functions (don't do this directly, use webmd.ads.googleDefer instead).
  // After the Google code loads, it replaces the push() function so instead of adding to the array,
  // it runs the function immediately.
  window.googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];

  /**
   * Ads framework
   */
  ads = {

    /**
     * Storage for ads that have been defined.
     * @private
     */
    ads: {},

    /**
     * Ad target values for all ads on the page.
     * This is an array of strings that will be concatenated to form the ad target.
     * For example, if you want the ad slot /1234/travel/asia/food, then the array
     * would be ['travel','asia','food'].
     *
     * <p>This parameter can be overridden, or more values can be added, but you
     * must do so before calling defineAd()</p>
     *
     * @example
     * // Override the ad target
     * webmd.ads.adTarget = ['consumer', 'rxlist'];
     *
     * @example
     * // Override the second part of the target
     * webmd.ads.adTarget[1] = 'rxlist';
     *
     * @example
     * // Set sensitive topic exclusion for consumer webmd
     * webmd.ads.adTarget[2] = 'st-conwbmd';
     */
    adTarget: ['consumer', 'webmd'],
    magdmdPrebidObj:{},

    /**
     * Google network code that is sent with each ad.
     * This, along with the adTarget parameter, is used when defining the ad slots.
     */
    networkCode: '',

    /**
     * identifier to know if disableInitialLoad has been called
     */
    initialLoadDisabled: false,

    /**
     * identifier to know  if doubleverify signal is loaded on the page
     */
    dvSignalLoaded: false,

    /**
     * identifier to know  if google tag failed to load
     */
    googleTagFailed: false,

    thirdPartyCallFromRefresh:false,
    /**
     * Storage for the page targets that have been set for all ads.
     * We don't technically need to save these, but this can be used
     * for reference after ads have been set up.
     * In particular it is used to determine when certain ads should be
     * blocked due to "safe select" requirements.
     *
     * @example
     * if (webmd.ads.pageTargets.pt == '1623') { ... }
     */
    pageTargets: {},


    /**
     * Storage for the page exclusions that have been set for all ads.
     * We don't technically need to save these, but this can be used
     * for reference after ads have been set up.
     * In particular it is used to determine when certain ads should be
     * blocked due to "safe select" requirements.
     *
     * @example
     * if (webmd.ads.pageExclusions.age11)) { ... }
     */
    pageExclusions: {},
    /**
     * Size overrides for individual ad positions.
     * This is an object with key/value pairs where the key is a pos value,
     * and the value is a size array like those passed into webmd.ads.defineAd()
     *
     * <p>
     * This can be used to set default sizes for all the ad positions
     * so you do not have to pass the size when you define the ad.
     * </p>
     *
     * <p>
     * It can also be used to define size overrides, in case you define an
     * ad with a set of sizes, but on certain pages you want to override those sizes.
     * In this case you must set the size override before defining the ad.
     * </p>
     *
     * <p>
     * Note: if a size is set here, any size passed to defineAd() is ignored.
     * </p>
     *
     * @example
     * // Set sizes for various ad positions
     * webmd.ads.sizes = {
     *   101: [ [300, 250], [300,600] ],
     *   121: [ 300, 250 ]
     * };
     * // ...
     * webmd.ads.defineAd({pos:101, id:'ads-pos-101'});
     *
     * @example
     * // Override the size for a single ad on this page
     * webmd.ads.sizes['101'] = [300,250];
     */
    sizes: {

      // posValue: sizesArray,
      // ...
    },

    /**
     * used to store the state of display function
     */
    displayCalled: false,
    displayCalledCount: 0,

    /**
     * used to store the state of refresh function
     */
    refreshCalled: false,


    /**
     * The amount of time we are going to delay the ad request in ms
     */
    delayTime: 0,

    /**
     * List of ad delay promises
     */
    adDelays: [],

    /**
     * used to store if delay has started
     */
    delayStarted: false,

    // flag check for block-though script
    btloaded : false,
    /**
     * used to store state of delay state to prevent creating delay promises for other ads
     */
    delayFullfilled: false,

    /*==================================================
     * START OF FUNCTIONS
     *==================================================*/

    /**
     * Function to call once to initialize the ads framework.
     * Can be done at the top or bottom of the page.
     * Calling this multiple times will have no effects.
     */
    init: function() {
      
      // Don't load gpt.js on webmdrx
      if(window.location.host.includes('webmdrx')){
        return false;
      }

      // Do a check to make sure nobody tries to run init twice
      if (this.init.flag) {
        return;
      }

      this.init.flag = true;
      // Checking if gpt failed to load
      Promise.resolve(window.__tcfapiPromise).then(function () {
        window.webmd.ads.isGoogleTagLoad();

        let gads = document.querySelector("[src='https://securepubads.g.doubleclick.net/tag/js/gpt.js']");

        /**
         * Check if perf marks have been set for google tag api & googletag pubads
         */

        if(!window.pMarks) {
          try {
            gads.onload = function() {
              window.webmd.ads.googleDefer(() => {
                if (window.googletag && window.googletag.apiReady) {
                  window.performance.mark('googletag-api-ready');
                  window.performance.measure('measure-googletag-api-ready', 'ads-code-load', 'googletag-api-ready');
                  debug('(Perf-Mark) googletag Api ready -> ' + window.performance.getEntriesByName('measure-googletag-api-ready', 'measure')[0].duration);
                }
                if (window.googletag && window.googletag.pubadsReady) {
                  window.performance.mark('googletag-pubads-ready');
                  window.performance.measure('measure-googletag-pubads-ready', 'ads-code-load', 'googletag-pubads-ready');
                  debug('(Perf-Mark) googletag pubads ready -> ' + window.performance.getEntriesByName('measure-googletag-pubads-ready', 'measure')[0].duration);
                }
              })
            }
            window.pMarks = true;
          } catch (e) {
            debug(e)
          }
        }
        
      });

      // set the Google network code
      this.networkCode = this.setNetworkCode();

      // Load the javascript library from google
      if (typeof window.googleloaded === "undefined") {
        this.googleLoad();
      }

      // CONSMEDIA-19920 - Feature detect the cookieDeprecationLabel API
      this.detectUserSegment();

      // Pass site name to DFP - https://jira.webmd.net/browse/PPE-143981
      if (typeof window.s_site !== 'undefined') {
        this.setPageTarget('sname', window.s_site);
      }

      
      if(window.__INITIAL_STATE__&& window.__INITIAL_STATE__.pagedata && window.__INITIAL_STATE__.pagedata.omniture && window.__INITIAL_STATE__.pagedata.omniture.s_cap_id){
        this.setPageTarget('cap', window.__INITIAL_STATE__.pagedata.omniture.s_cap_id);
      }
      // pass ECD code into ad call if it is present, otherwise pass ecd=0 - https://jira.webmd.net/browse/PPE-120734
      if (getParam('ecd')) {
        this.setPageTarget('ecd', getParam('ecd'));
      } else {
        this.setPageTarget('ecd', 0);
      }

      // pass page target DCT KVP as 1 for automation traffic soaker line, otherwise pass DCT=0 - https://youtrack.internetbrands.com/issue/CONSMEDIA-23138
      let autoFlag = window.localStorage.getItem('automation');
      if ((getParam('automation') && getParam('automation') === 'true') || (autoFlag && autoFlag == 'true' )) {
        this.setPageTarget('dct', 1);
      } else {
        this.setPageTarget('dct', 0);
      }

      // pass alternative refrerrer value iaf in to ad calls - CONSMEDIA-20401
      this.setAlternativeReferrer();

       // pass fbAdId code into ad call if it is present - https://jira.webmd.net/browse/PPE-330847
       let fbAdId = getParam('adID');
       if(fbAdId) {
         this.setPageTarget('adid', fbAdId);
       }

      // pass Viewport device into ad call if device is mobile - https://jira.internetbrands.com/browse/PPE-452799
      if (ua.type === 'mobile') {
        this.setPageTarget('ismbl', 1);
      }
      
      // Set page targets for A/B testing of Magnite demand and MediaNet
      if (typeof window.prebidExperiment === 'boolean') {
        if (window.prebidExperiment) {
            this.setPageTarget('pb', 1);  
        } else {
            this.setPageTarget('mn', 1);  
        }
      }
    
      //setting up the cookie to store the url and to load the vendor code for IA pages
      cookie.setJson('initial_url_path',{ 'url': window.location.pathname });

      // set mobile IU parts based on application
      this.setIuParts();

      this.setGptEvents();

      /*Dispatching an event to state that ads code is ready*/
      document.dispatchEvent(new CustomEvent('ads_code_ready'));

      // get delay param 
      let delay = getParam('adDelay');
      if (delay && !isNaN(delay)) {
        this.delayTime = parseInt(delay);
      } 

      
      return this;
    },

    shouldRemoveAds: function() {
      // Check if window.location and window.location.search are defined
      if (typeof window !== 'undefined' && window.location) {
        return window.location.href.indexOf('conmktvid') > -1;
      }
      return false; // Return false if the checks fail
    },


    /**
     * Function to tell if init() has already been called.
     * You can use this to determine if DFP ads are defined on the page.
     * NOTE: this must be called after webmd.ads2.init() has been called,
     * otherwise it will report that DFP ads are not on the page.
     * @returns Boolean
     */
    isInitialized: function() {
      return Boolean(this.init.flag);
    },

    /**
    * https://youtrack.internetbrands.com/issue/CONSMEDIA-20401
    * Function to pass the iaf key value pairs to the ad call
    * Updated the iaf from 1 to counter (1,2,3 etc.,)
    * Initial Value for iaf value will be 1.
    * iaf value will be always 1 when the ecd param is available or the referrer is google.
    */
    setAlternativeReferrer: function () {
      try {
        if(getParam('ecd')) {
          sessionStorage.setItem('iaf', '2');
        } else {
          if(sessionStorage.getItem('iaf')) {
            let iafValue = sessionStorage.getItem('iaf');
            sessionStorage.setItem('iaf', ++iafValue);
          } else {
            sessionStorage.setItem('iaf', '1');
          }
        }
        this.setPageTarget('iaf', sessionStorage.getItem('iaf'));
      } catch (e) {
        console.log(e);
      }
    },

    /* set mobile IU parts based on application*/
    setIuParts: function() {
      this.adTarget = ['consumer', 'webmd'];
      if(window.s_pagename && this.adTarget[1] && window.s_pagename.indexOf('vitals.') > -1){
          this.adTarget[1] = 'vitals';
      }
      if (ua.type === 'mobile') {
            this.adTarget[0] = 'consmobileweb';
            switch (this.adTarget[1]) {
              case 'vitals':
                this.adTarget[1] = 'vitalsmobileweb';
                break;
              case 'webmd':
                this.adTarget[1] = 'webmdmobileweb';
                break;
              default: // do nothing
            }
          }
    },

    /**
     * Call this once to load the google code.
     * For best results call this near the top of the page.
     * This function is called automatically by init()
     */
    googleLoad: function() {
      let gads, node, self = this;

      // Asynchronously load the google code
      gads = document.createElement("script");
      gads.async = true;
      gads.type = "text/javascript";
      gads.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
      /**
       *
       * We need to add a promise object in the IAB stub code to make sure that tcfapi.js
       * gets set in time before we make any ad calls.
       *
       * We need to check for the Promise to be resolved, which happens after tcfapi.js is loaded,
       * and then fire the ads code, i.e., load gpt.js after tcfapi.js has been loaded
       *
       * tcfapi.js is loaded only in EU locations and in other locations the Promise is
       * resolved immediately (handled in IAB stub code - webmd-ccm.js)
       *
       * Ref: https://jira.internetbrands.com/browse/PPE-279145
      */

      Promise.resolve(window.__tcfapiPromise).then(function () {
        node = document.getElementsByTagName("script")[0];
        node.parentNode.insertBefore(gads, node);
        window.googleloaded = true;

        /**
         * Check if perf marks have been set for google tag api & googletag pubads
         */
        if(!window.pMarks) {
          try {
            gads.onload = function() {
              self.googleDefer(() => {
                if (window.googletag && window.googletag.apiReady) {
                  window.performance.mark('googletag-api-ready');
                  window.performance.measure('measure-googletag-api-ready', 'ads-code-load', 'googletag-api-ready');
                  debug('(Perf-Mark) googletag Api ready -> ' + window.performance.getEntriesByName('measure-googletag-api-ready', 'measure')[0].duration);
                }
                if (window.googletag && window.googletag.pubadsReady) {
                  window.performance.mark('googletag-pubads-ready');
                  window.performance.measure('measure-googletag-pubads-ready', 'ads-code-load', 'googletag-pubads-ready');
                  debug('(Perf-Mark) googletag pubads ready -> ' + window.performance.getEntriesByName('measure-googletag-pubads-ready', 'measure')[0].duration);
                }
              })
            }
            window.pMarks = true;
          } catch (e) {
            debug(e)
          }
        }
      });
      // Allow this function to be chained
      return this;
    },

    /**
     * Add a function to the google asynchronous command queue.
     *
     * @param Function f Function to run after google code has loaded.
     * @param Number i Index for the new function to be pushed into.
     */
    googleDefer: function(f) {
      // Push the function onto the command array so google can run it later.
      //
      // NOTE: After the google code loads, it actually overrides the push() function
      // so instead of adding to the array, it runs the function immediately.
      // Because of this you should only modify the array using the push() function,
      // you should not attempt to add functions to the queue any other way.
      googletag.cmd.push(f);

      // Allow this function to be chained
      return this;
    },

    /**
     * Set a page-level key/value target that will be used for all ads.
     * This function can set a single key/value, or multiple key/value pairs.
     * The value can be a single value, or an array of values.
     *
     * @param String|Object key The name of the key to add, or an object containing multiple key/value pairs.
     *
     * @param String|Array [value] If the "key" parameter is a string, then this is the value for the single key to set.
     * If the "key" parameter is an object, this parameter is not used.
     * The value can be a string, or an array of values.
     * The value cannot be a number, however it can be an array of numbers (possible bug in google code?)
     *
     * @example
     * // Set a single key/value
     * webmd.ads.setPageTarget('xpg', '1234');
     *
     * @example
     * // Set a single key with multiple values
     * webmd.ads.setPageTarget('xpg', ['1234', '5678']);
     *
     * @example
     * // Set multiple key/value pairs all at once
     * webmd.ads.setPageTarget({xpg:'1234', gender:'male', m:[1,2,5]});
     */
    setPageTarget: function(key, value) {

      // We can't call the google code until it is loaded,
      // so we'll add a command to the queue to run later
      this.googleDefer(() => {

        // Check if "key" is a plain object i.e not a primitive
        if (typeof key === 'object' && key.constructor === Object) {

          // Loop through multiple key/value pairs
          let i = Object.keys(key);
          i.forEach( (val) => {
            key[val] = String(this.fixTarget(val, key[val]));

            // Add the key and value
            // Note: for some reason the DFP code does not allow
            // numeric values, so cast the value to a String
            googletag.pubads().setTargeting(val, key[val]);
            this.pageTargets[val] = key[val];
          });

        } else { // Add a single key and value

          value = String(this.fixTarget(key, value));
          googletag.pubads().setTargeting(key, value);
          this.pageTargets[key] = value;

        }

      });

      // Allow this function to be chained
      return this;
    },

    fixTarget: function(key, value) {

      // Fix some of the targets because runtime sends some extraneous text that we don't want
      if (key === 'env') {
        value = value.replace(/&amp;env=/, '');
      }
      if (key === 'leaf') {
        value = value.replace(/&amp;leaf=/, '');
      }
      if (key === 'uri') {
        value = decodeURIComponent(value);
      }

      return value;
    },

    /**
     * Sets a "category exclusion" for all ads on the page.
     *
     * <p>Note we currently do not support setting a category exclusion just for a single ad.</p>
     *
     * @param String|Array label The name of the category exclusion label, or an array of names.
     *
     * @example
     * webmd.ads.setPageExclusion('gen2');
     *
     * @example
     * webmd.ads.setPageExclusion(['gen2', 'age11']);
     */
    setPageExclusion: function(label) {

      // Turn label into an array if it is not already an array
      label = Array.isArray(label) ? label : [label];

      // Wait for google code to be loaded
      this.googleDefer(() => {

        // Loop through the array of labels and set a category exclusion for each one
        label.forEach( (label) => {
          googletag.pubads().setCategoryExclusion(label);

          // Save the exclusion label for later reference
          this.pageExclusions[label] = true;
        });
      });

      // Allow this function to be chained
      return this;
    },

    /**
     * Sets multiple "category exclusions" based on a concatenated string.
     * This is provided for legacy systems that used to pass a value like
     * "_label1_label2_" to the ad server. This function will break apart
     * the string into multiple exclusion labels.
     *
     * @param String labels A string containing one or more labels separated
     * by an underscore character.
     *
     * @example
     * webmd.ads.setPageExclusionUnderscore('_gen2_m32_h16_o92_age11_age121_age122_');
     */
    setPageExclusionUnderscore: function(labels) {

      // Make sure we actually got a string
      labels = labels || '';

      labels.split('_').forEach( (label) => {

        if (label) {
          this.setPageExclusion(label);
        }
      });

      // Allow this function to be chained
      return this;
    },

    removePageExclusion: function (label) {

      // Turn label into an array if it is not already an array
      label = Array.isArray(label) ? label : [label];

      // Wait for google code to be loaded
      this.googleDefer(() => {

        // Loop through the array of labels and set a category exclusion for each one
        label.forEach((label) => {
          googletag.pubads().clearCategoryExclusions(label);

          // Save the exclusion label for later reference
          this.pageExclusions[label] = false;
        });
      });

      // Allow this function to be chained
      return this;
    },

    /**
     * Check if the google tag is failed to load within 5 seconds.
     * If it is failed then dispacth the custom event GOOGLE_ADS_FAILED
     */
    isGoogleTagLoad() {
      let totalwaittime;
      if (getParam('twt')) {
        totalwaittime = getParam('twt');
      } else {
        totalwaittime = 7000;
      }

      setTimeout(function () {
        if (window.googletag && !window.googletag.apiReady) {
          window.webmd.ads.googleTagFailed = true;
          window.document.dispatchEvent(new CustomEvent('wbmd:ads_googletag_failed'));
          window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-ads", "webmd-ads-googletag-failed-timedout");
          debug('GOOGLE_ADS_FAILED');
        } else {
          window.webmd.ads.googleTagFailed = false;
        }
      }, totalwaittime);
    },

    /**
     * Define an ad slot on the page. Generally you will have already created a div on the page as the ad placeholder,
     * then call this function and pass in the id of that div.  However, you can call this function if necessary before
     * the div has been created.
     *
     * @param Object settings A set of key/value pairs that configures the ad.
     *
     * @param Boolean [settings.collapseAfter] Set this to true if you want the ad to collapse when
     * the ad server returns a blank. If this is not specified then the ad will use
     * the page default behavior (which is to not collapse the ad).
     *
     * @param Boolean [settings.collapseBefore] Set this to true if you want the ad to be
     * collapsed immediately. The ad will expand if the ad server returns an ad.
     * If this is not specified then the ad will use the page default behavior
     * (which is to not collapse the ad).
     *
     * @param String settings.id The id attribute for the ad placeholder div.
     * Each ad must have a unique id. For example, 'ads-pos-5000'.
     *
     * @param Boolean [settings.immediate=false] Immediately display the ad you defined.
     * This only has an effect if you are defining a new ad after the initial ad call has already been made.
     * It refreshes only the ad that is being defined. If you need to refresh other ads on the
     * page you should not use this.
     *
     * @param Object [settings.keys] Optional set of key/value pairs to set targeting only for
     * this individual ad. Note we typically do not set targeting for individual ads,
     * so use setPageTarget() if you want to set a global target used by all ads.
     *
     * @param String settings.pos The POS value for the ad. Each ad on the page must have a POS
     * value that is unique on the page. For example, '5000'.
     *
     * @param Object [settings.refresh=true] Set this to false if this ad should
     * not be refreshed when calling the webmd.ads.refresh() function.
     *
     * @param Array [settings.sizes=webmd.ads.sizes] An array of sizes for the ad.
     * This can be width height values, or multiple width/height pairs.
     * For example, [350,250] or [[300,250],[300,600]].
     * If a value is set within webmd.ads.sizes for the POS value of this ad, then this parameter
     * is ignored, and the value within webmd.ads.sizes is used instead.
     * A size must be defined using one of these methods or an error will occur.
     *
     * @example
     * // Ad that supports a single size
     * webmd.ads.defineAd({id:'ads-pos-5000', pos:5000, sizes:[300,250]});
     *
     * @example
     * // Ad that supports two different sizes
     * webmd.ads.defineAd({id:'ads-pos-5000', pos:5000, sizes:[[300,250], [300,600]]});
     *
     * @example
     * // Create an ad that should not be refreshed
     * webmd.ads.defineAd({id:'ads-pos-5000', pos:5000, sizes:[300,250], refresh:false});
     *
     * @example
     * // Set default ad size so the size does not have to be supplied in the defineAd function
     * webmd.ads.sizes['5000'] = [300,600];
     * // ...
     * webmd.ads.defineAd({id:'ads-pos-5000', pos:5000});
     *
     * @example
     * // Override an ad size
     * webmd.ads.sizes['5000'] = [300,600];
     * // ...
     * webmd.ads.defineAd({id:'ads-pos-5000', pos:5000, sizes:[300,250]});
     * // Result: ad will use sizes [300,600] instead of [300,250]
     *
     * @example
     * // Define a new ad after the other ads have already loaded,
     * // and immediately load that ad plus refresh the other ads
     * webmd.ads.defineAd({id:'my-new-ad', pos:121, sizes:[300,250]}).refresh()
     *
     * @example
     * // Define a new ad after the other ads have already loaded,
     * // and immediately load only that ad
     * webmd.ads.defineAd({id:'my-new-ad', pos:121, sizes:[300,250]}).refresh({id:'my-new-ad'})
     */
    defineAd: function(settings) {

      let ignore, fn;

      // Make sure settings is an object
      settings = settings || {};

      // Check if this ad should be ignored based on a global override.
      // Uses a global variable "ads_ignore", which must be an object
      // where the key is the pos value of the ad that should be ignored,
      // and the value is a boolean (true=ignore the ad).
      // This is used by certain products such as Answers that
      // need to deploy a single template with multiple ads,
      // then show or hide various ads based on back-end logic.
      //
      // Examples:
      //
      // // Ignore ad position 101
      // var ads_ignore = { 101: true };
      //
      // // Ignore all the ads
      // var ads_ignore = { all:true };
      //
      // // Ignore the ads based on the slot ID
      // var ads_ignore = { "ad-pos-101-1":true };

      ignore = window.ads_ignore || {};
      if (ignore.all || ignore[settings.pos] || ignore[settings.id]) {
        return;
      }
      // Check if ads should be removed based on the 'conmktvid' parameter
      if (this.shouldRemoveAds()) {
        debug("Ads initialization skipped due to 'conmktvid' parameter in URL.");
        const parentElements = document.querySelectorAll('div[class^="ads2"], div[class^="ads"], div[class*="module ad"]');
        parentElements.forEach(parent => {
            parent.style.display = 'none';
        });
        return; // Skip the rest of the initialization if 'conmktvid' is present
      }

       // setting this up as we are seeing house ads on some sponsored pages - End team may not updating 
       if(window.googletag && window.googletag.pubads && this.displayCalled){
          window.googletag.pubads().updateCorrelator();
       }

      // Check if sizes were provided.
      // If webmd.ads.sizes contains sizes for this POS value, use that to override the size.
      // Otherwise use the sizes that are passed into this function settings.sizes
      settings.sizes = this.sizes[settings.pos] || settings.sizes;

      // Check for required settings
      if (!(settings.id && settings.sizes && settings.pos)) {
        throw ('Missing id, pos, or sizes for defineAd');
      }

      // Save these settings because we will use them later to actually display the ads
      this.ads[settings.id] = settings;

      // Add to the google command queue
      this.googleDefer(() => {

        // Pass the pageview id as a page target
        
          this.setPageTarget('pvid', getPvid());

         // pass the avid as the page target, Avid will update only once per article/contenttype. 
          this.setPageTarget('avid', getAvid());
        

        // https://jira.webmd.net/browse/PPE-157179: Pass pim value to ad server
        this.setPageTarget('pimc', getCount());

        debug('define ad');

        let adUnit, adSlot;

        adUnit = '/' + this.networkCode + '/' + this.adTarget.join('/');

        // Create the ad slot and set the "pos" key
        adSlot = googletag.defineSlot(adUnit, settings.sizes, settings.id)

          // Ads can have different services associated with them, so add a service
          .addService(googletag.pubads())

          // Set the pos key for this individual ad
          .setTargeting('pos', settings.pos);

        // Set the optimera keys for display ad slots
        // if not in an iframe
        if (window.top === window.self && window.__optimeraPromise &&
          optimera && optimera.ispassOptimeraPos(settings.pos)) {
          webmd.optimera.isOpsCalled = true;
          window.__optimeraPromise.then(function () {
            adSlot.setTargeting('optimera',window.oVa[settings.id] ? window.oVa[settings.id] : 'NDS');
          }).catch(function () {
            adSlot.setTargeting('optimera',window.oVa[settings.id] ? window.oVa[settings.id] : 'NULL');
          });
        }

        // Save the ad slot for future use when we refresh ads
        settings.slot = adSlot;

        // Set extra individual targeting keys if any were provided
        if (settings.keys) {

          Object.keys(settings.keys).forEach( (value) => {
            adSlot.setTargeting(value, settings.keys[value]);
          });
        }

        // Override the page-default collapse behavior
        // (only if one of these is set to true)
        if (settings.collapseAfter || settings.collapseBefore) {
          adSlot.setCollapseEmptyDiv(settings.collapseAfter, settings.collapseBefore);
        }

        /**
         * if we define an ad after webmd.ads.display() has been called,
         * the ad will be fetched and displayed by default.
         *
         * Special case: if we don't want to display by default then we need to set the
         * "immediate" flag to false, it only initializes the ad space.
         * you must call refresh() to fetch the ad
         *
         * "immediate" flag by default is 'undefined' and will pass the display condition
         * as we are strictly checking with Boolean 'false'
         */
        if (this.display.flag && (settings.immediate !== false)) {

          fn = () => {

            /**
             * for ads defined after initial load when disableInitialLoad
             * is called but settings.immediate is set
             */
            if (this.initialLoadDisabled && settings.immediate) {
              this.refresh({ id: settings.id });
            } else {
              /**
               * we are delaying the function call so that the googletag api can look for other
               * avaliable slots
               *
               * this is to add a delay so that multiple slots can be combined
               * in to a single ad call. This is called only when the disable Initial load  not called
               */
              new Promise(resolve => setTimeout(resolve, 100)).then(() => {
                /**
                * Double Verify Unity Tag Implementation 
                */
                this.onDvtagReady(function() {
                  googletag.display(settings.id);
                });
              })
            }
          };
   
          // if there are third party ad services, we will call those services and send googletag.display as a callback
          if (typeof window.tpsvc !== 'undefined') {
            this.callThirdPartyAdServices(fn);
          } else {
            /**
             * we are delaying the function call so that the googletag api can look for other
             * avaliable slots
             *
             * this is to add a delay so that multiple slots can be combined
             * in to a single ad call
             */
            setTimeout(function(){
              fn();
            }, 100);
          }

        }
      });

      // Allow this function to be chained
      return this;
    },

    isChromeBrowser: function () {
      // Check if the user is on a Chrome browser
      var browserUserAgent = navigator && navigator.userAgent ? navigator.userAgent : null;
      if (!browserUserAgent) {
        return false;
      }
    
      // Check for Chrome on Desktop or Android
      var isChrome = /Chrome\/\d+/.test(browserUserAgent) && !/CriOS/.test(browserUserAgent);
    
      // Check for Chrome on iOS (CriOS)
      var isChromeIOS = /CriOS\/\d+/.test(browserUserAgent);
    
      if (isChrome || isChromeIOS) {
        return true;
      }
      return false;
    },
    
    // CONSMEDIA-19920 - Feature detect the cookieDeprecationLabel API
    detectUserSegment: async function(){
      
      var isChromeBrowser = this.isChromeBrowser();
      
      if (isChromeBrowser) {
        // Check if the API is available in navigator
        if (navigator && ('cookieDeprecationLabel' in navigator)) {
          try {
            // Request the value and log "MODE B" if the browser is in the 1% group
            var label = await navigator.cookieDeprecationLabel.getValue();

            // The label values for MODE B are treatment_1.1, treatment_1.2, treatment_1.3, control_2
            if (label && (label.includes('treatment_1.') || label === 'control_2')) {
              this.setPageTarget('tpy', 'B');
            } else {
              this.setPageTarget('tpy', 'A');
            }
          } catch (error) {
            this.setPageTarget('tpy', 'A');
          }
        }else{
          // Log "MODE A" if the API is unavailable
          this.setPageTarget('tpy', 'A');
        }
      }else{
        this.setPageTarget('tpy', '0');
      }
    },

    /**
     * Make the ad call to get all ads, then display the ads.
     * This must be called after all ads have been defined on the page
     * with a call to defineAd() for each one.
     *
     * If you call disableInitialLoad() before calling this function, then the ads will be initialized but will not
     * be loaded and displayed. Then you can call refresh() to later display the ads. This is useful in cases where you
     * need to wait for some other event (for example, to set targeting values) before you load the ads.
     */
    display: function() {

      let runDisplay, wait;

      this.googleDefer(() => {

        // display has been called
        this.displayCalled = true;
        // increment the count
        this.displayCalledCount++;

        //trigger DFP_DISPLAY_CALLED only first time the display is called
        if (this.displayCalledCount === 1) {
          document.dispatchEvent(new CustomEvent('DFP_DISPLAY_CALLED'));

        }

        debug('display');

        if(window.s_topic && window.semiTransparent && window.semiTransparent.includes(window.s_topic)) {
          // masking the "url" parameter to only be the hostname-no subdomians
          googletag.pubads().set("page_url", window.location.protocol + '//www.' + getSLD());
        }
        else {
          // pass the full url
          googletag.pubads().set("page_url", window.location.href);
        }

        // Directs the publisher ads service to make a single request
        // when fetching content for multiple ad slots.
        // This should be called prior to enabling the service.
        googletag.pubads().enableSingleRequest();

        // CONSMEDIA-20491: New PPID Logic
        var ppid = cookie.get('ppid')

        // if cookie doesnt exist, generate new PPID and set new cookie
        if ( !ppid || ppid.length === 0 ) {
          ppid = this.generatePPID();
          cookie.set('ppid', ppid, { expires:180 })
        }
        googletag.pubads().setPublisherProvidedId(ppid);

        // Enables all Google Publisher Tag services that have been defined for ad slots on the page.
        // This is only needed once per page but including it multiple times will not cause any harm.
        googletag.enableServices();

        runDisplay = () => {   
          // Call display on the ads.
          // Since we are doing enableSingleRequest, the call to display() the first add will make
          // the call to DFP to fetch all the ads. But we must still call display() for each ad on the page.
          Object.keys(this.ads).forEach( (id) => {
            var pos = this.ads[id] && this.ads[id].pos;
            var adSlot = this.ads[id] && this.ads[id].slot;
            // Set the optimera keys for display ad slots
            // if not in an iframe
            
            if (window.top === window.self && window.__optimeraPromise &&
              optimera && optimera.ispassOptimeraPos(pos)) {
              optimera.isOpsCalled = true;
              window.__optimeraPromise.then(function () {
                adSlot.setTargeting('optimera',window.oVa[id] ? window.oVa[id] : 'NDS');
              }).catch(function () {
                adSlot.setTargeting('optimera',window.oVa[id] ? window.oVa[id] : 'NULL');
              });
            }
            /**
            * Double Verify Unity Tag Implementation 
            */
            this.onDvtagReady(function() {
              googletag.display(id);
            });
            

            // Set a flag so we know that "display" has already been called.
            // This is used when we add another ad on the page: if display has already been called
            // we must call display() on the ad right when we define the ad.
            this.display.flag = true;
          });

          try {
            window.performance.mark('googletag-ads-display-called');
            window.performance.measure('measure-googletag-ads-display-called', 'ads-code-load', 'googletag-ads-display-called');
            debug('(Perf-Mark) googletag display called -> ' + window.performance.getEntriesByName('measure-googletag-ads-display-called', 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        };
   
        if(this.delayTime > 0 && !this.delayFullfilled) {
          // ad delay promise
          wait = new Promise((resolve) => {
            if(!this.delayStarted) {
              console.log('[AD DELAY] START: ', Date())
              this.delayStarted = true;
            }
            
            setTimeout(function () {
              resolve()
            }, this.delayTime);
          });

          this.adDelays.push(wait);
          Promise.any(this.adDelays).then(() => {
            ads.delayFullfilled = true
            console.log('[AD DELAY] FINISHED: ', Date())

            // if there are 3rd party ad services to be executed, call them.
            if (typeof window.tpsvc !== 'undefined') {
              if(this.initialLoadDisabled){
                //to check whether the prebid is called from display when initial load is disabled
                document.dispatchEvent(new CustomEvent('prebidForDisplay'));
              }
              this.callThirdPartyAdServices(runDisplay);
            } else {
              runDisplay();
            }

        });
        }
        else {
          // if there are 3rd party ad services to be executed, call them.
          if (typeof window.tpsvc !== 'undefined') {
            if(this.initialLoadDisabled){
                //to check whether the prebid is called from display when initial load is disabled
              document.dispatchEvent(new CustomEvent('prebidForDisplay'));
            }
            this.callThirdPartyAdServices(runDisplay);
          } else {
            runDisplay();
          }
        }
        
      });

      // if ad blocker is enabled and blockthrough isnt suppressed check for sponsorships before setting up Blockthrough script
      if (!window.noBt) {
        window.__INITIAL_STATE__ = window.__INITIAL_STATE__ || {};
        window.__INITIAL_STATE__.pagedata = window.__INITIAL_STATE__.pagedata || {ad:{targets:{leaf:''}}};
        let lef = window.__INITIAL_STATE__.pagedata.ad.targets.leaf;
        let spTarget = this.adTarget.some(item => item.includes("-sp"))

        // check list of sponsored URLs
        const checkSponsoredList = fetch('https://img.lb.staging.wbmdstatic.com/webmd_static_vue/file-explorer/webmd/consumer_assets/site_images/block-through/sponsored.json');
        checkSponsoredList.then(response => {
          return response.json();
        }).then(data => {

          // check if current url is in list of sponsored urls
          window.sponsoredUrl = data.sponsoredUrls.includes(window.location.href.split('?')[0]);
          if (!this.btloaded && !spTarget && (!lef || lef === '') && (!window.s_sponsor_program || window.s_sponsor_program === '') && !window.sponsoredUrl) {
            if (window.s_sensitive && window.s_sensitive === 'false') {
              document.dispatchEvent(new CustomEvent('BLOCKTHROUGH_SETUP'));
              this.btloaded = true;
            }
          }
        }).catch(e => {
          debug(e)
        }); 
      }

      // Allow this function to be chained
      return this;
    },

    /**
     * set the googletag events to capture metrics
     */
    setGptEvents: function () {
      this.googleDefer(() => {
        
        // slot is requested
        window.googletag.pubads().addEventListener('slotRequested', function (event) {
          try{
            let slotElementId = event.slot.getSlotElementId();
            /**
             * mark when ad slot is requested
             */
            window.performance.mark(`ad-slot-${slotElementId}-requested`);
            window.performance.measure(`measure-ad-slot-${slotElementId}-requested`, 'ads-code-load', `ad-slot-${slotElementId}-requested`);
            debug(`(Perf-Mark) ${slotElementId} slot requested -> ` + window.performance.getEntriesByName(`measure-ad-slot-${slotElementId}-requested`, 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        });

        // slot response received
        window.googletag.pubads().addEventListener('slotResponseReceived', function (event) {
          try{
            let slotElementId = event.slot.getSlotElementId();
            /**
             * mark when ad slot response is received
             */
            window.firstAdReceived = true;
            window.performance.mark(`ad-slot-${slotElementId}-response-received`);
            window.performance.measure(`measure-ad-slot-${slotElementId}-response-received`, 'ads-code-load', `ad-slot-${slotElementId}-response-received`);
            debug(`(Perf-Mark) ${slotElementId} slot response received -> ` + window.performance.getEntriesByName(`measure-ad-slot-${slotElementId}-response-received`, 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        });

        // slot render ended
        window.googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          try{
            let slotElementId = event.slot.getSlotElementId();
            /**
             * mark when ad slot render is ended
             */
            window.performance.mark(`ad-slot-${slotElementId}-render-ended`);
            window.performance.measure(`measure-ad-slot-${slotElementId}-render-ended`, 'ads-code-load', `ad-slot-${slotElementId}-render-ended`);
            debug(`(Perf-Mark) ${slotElementId} slot render-ended -> ` + window.performance.getEntriesByName(`measure-ad-slot-${slotElementId}-render-ended`, 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        });

        // slot onload
        window.googletag.pubads().addEventListener('slotOnload', function (event) {
          try{
            let slotElementId = event.slot.getSlotElementId();
            /**
             * mark when ad slot is loaded
             */
            window.performance.mark(`on-ad-slot-${slotElementId}-load`);
            window.performance.measure(`measure-on-ad-slot-${slotElementId}-load`, 'ads-code-load', `on-ad-slot-${slotElementId}-load`);
            debug(`(Perf-Mark) ${slotElementId} slot loaded -> ` + window.performance.getEntriesByName(`measure-on-ad-slot-${slotElementId}-load`, 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        });

        // Impression becomes viewable
        window.googletag.pubads().addEventListener('impressionViewable', function (event) {
          try{
            let slotElementId = event.slot.getSlotElementId();
            /**
             * mark when ad slot is viewable
             */
            window.performance.mark(`ad-slot-${slotElementId}-impression-viewable`);
            window.performance.measure(`measure-ad-slot-${slotElementId}-impression-viewable`, 'ads-code-load', `ad-slot-${slotElementId}-impression-viewable`);
            debug(`(Perf-Mark) ${slotElementId} slot viewable -> ` + window.performance.getEntriesByName(`measure-ad-slot-${slotElementId}-impression-viewable`, 'measure')[0].duration);
          } catch (error) {
            debug(error)
          }
        });
        
        
      });
		},

    /*
     * Proxy method to all 3rd party ad services.
     * All 3rd party Ad service handlers are stored in the thirdPartyAdServices global variable.
     * This method executes each of those handlers and delays the ad request for a specified length of time
     * so that 3rd party ad services get a chance to complete processing.
     * if all services finish processing before the timeout elapses, the ad request is sent.
     * otherwise, the ad request will be sent once the timeout expires.
     *
     * This all happens asynchronously to allow us to work with multiple 3rd party services
     * while keeping the timeout delay near constant.
     *
     * @param Object adRequest - Ad request handler.
     * @return {void}
     */
    callThirdPartyAdServices: function(adRequest) {
      let
        q = [],
        wait,
        len;

      if (typeof window.tpsvc === 'undefined') {
        adRequest();
        return;
      }

      // if there are no 3rd party ad services to be executed, make the ad request and exit
      len = window.tpsvc.cmds.length;

      if (len < 1) {
        adRequest();
        return;
      }

      // call all 3rd ad party services that have been defined and queued in the services array
      for (let i = 0; i < len; i++) {
        try {
          //Added setTimeout to avoid blocking the main thread
          setTimeout(() => window.tpsvc.cmds[i].call(), 0);
        } catch (e) {
          debug(e);
        }
      }

      //for IA pages, if the url has changed, then updating the vendorCodeforIA cookie -PPE-337073
      var initial_url_path = cookie('initial_url_path');
      if (initial_url_path) {
        initial_url_path = JSON.parse(initial_url_path);
        if (initial_url_path.url !== window.location.pathname) {
          cookie.setJson('initial_url_path',{ 'url': window.location.pathname });
        }
      }

      /*
       * @param Number ms - This is the length of time we will wait for all 3rd party ad services to finish processing before we make the ad request
       */
      
      wait = (ms) => {
        return new Promise( (resolve) => {
          setTimeout(function() {
            resolve();
          }, ms);
        });
      };
  
      q.push(new Promise( (resolve) => {
        wait(800).then(function() {

            resolve('timeout elapsed: requesting ads now');
        });
      }));


      q.push(new Promise( (resolve) => {
        // resolve this promise when all 3rd party promises have resolved.
        Promise.all(window.tpsvc.promises).then( (iterable) => {
          resolve(iterable);
          debug('all 3rd party services completed');
        });
      }));
      

      // Promise is resolved when the all services have completed, or the timeout has been reached.
      // whichever happens first.
      Promise.race(q).then( (result) => {
        //if pb is 1 then pass the adRequest function to pbjs callback method
        if(this.pageTargets && this.pageTargets.pb == 1 && (this.thirdPartyCallFromRefresh|| this.display.flag==true))
        {
          // it will store the ad call request from refresh or when the display count is 2 as on page refresh the display call value is 2 on inital load
          if(this.thirdPartyCallFromRefresh || this.displayCalledCount>2){
            this.magdmdPrebidObj={
              adRequestCall:adRequest
            }
          }
         
          debug(result);
          this.thirdPartyCallFromRefresh=false;
   
        }
        else{
          adRequest();
          debug(result);
        }



      });
    },

    /**
     * Refresh some or all ads on the page. The ads must have been created with a call to webmd.ads.defineAd()
     *
     * @param Object [settings] A set of key/value pairs that configure which ads to refresh.
     *
     * @param Object [settings.keys] Optional set of key/value pairs to set page targeting.
     * Refer to setPageTarget() for more information.
     *
     * @param String|Array [settings.id] The id of an ad to refresh,
     * or an object with several ad ids to refresh.
     * If this parameter is used, then only the ads specified here will be refreshed.
     * If the id is in this list, then even if the ad was defined with refresh:false setting,
     * it will force a refresh.
     *
     * @param String|Array [settings.idSkip] The id of an ad to exclude from refresh,
     * or an object with several ad ids to exclude from refresh.
     * This parameter cannot be used if the settings.id parameter is used.
     *
     * @param String|Array [settings.pos] The POS value of an ad to refresh,
     * or an object with several ad positions to refresh.
     * If this parameter is used, then only the ads specified here will be refreshed.
     * If the pos value is in this list, then even if the ad was defined with refresh:false setting,
     * it will force a refresh.
     *
     * @param String|Array [settings.posSkip] The POS value of an ad to exclude from refresh,
     * or an object with several ad positions to exclude from refresh.
     * This parameter cannot be used if the settings.pos parameter is used.
     *
     * @example
     * // Refresh all ads except those that were defined with refresh:false
     * webmd.ads.refresh()
     *
     * @example
     * // Refresh all ads except those that were defined with refresh:false,
     * // and change the page targeting before refreshing the ads
     * webmd.ads.refresh({keys:{xpg:"1012"}})
     *
     * @example
     * // Refresh a single ad position
     * webmd.ads.refresh({pos:5000});
     *
     * @example
     * // Refresh several ad positions
     * webmd.ads.refresh({pos:{5000:true,5001:true}});
     *
     * @example
     * // Refresh all ads except for one ad position
     * webmd.ads.refresh({posSkip:5000});
     *
     * @example
     * // Refresh all ads except for several ad positions
     * webmd.ads.refresh({posSkip:{5000:true,5001:true}});
     */
    refresh: function(settings) {
      let fn;

      // Make sure this is an object in case nothing was passed in
      settings = settings || {};
      // Check if ads should be removed based on the 'conmktvid' parameter
      if (this.shouldRemoveAds()) {
        debug("Ads initialization skipped due to 'conmktvid' parameter in URL.");
        const parentElements = document.querySelectorAll('div[class^="ads2"], div[class^="ads"], div[class*="module ad"]');
        parentElements.forEach(parent => {
            parent.style.display = 'none';
        });
        return; // Skip the rest of the initialization if 'conmktvid' is present
      }

      const invokeRefreshLogic = () => {

        debug('refresh');

        // pass the current value of pimc in refresh call
        this.setPageTarget('pimc', getCount());

        // Pass the pageview id as a page target
       
        this.setPageTarget('pvid', getPvid());
        
        // pass the avid as the page target, Avid will update only once per article/contenttype. 
        this.setPageTarget('avid', getAvid());
        


        // Create an array of slots to send to refresh function.
        this.slots = [];

        // Set page targeting if new keys were provided
        if (settings.keys) {
          this.setPageTarget(settings.keys);
        }

        // Pass nlid cookie value to DFP
        var nlidCookieValue = cookie.get('nlsub');
        if(nlidCookieValue && nlidCookieValue.length > 0) {
          this.setPageTarget('nlsub', nlidCookieValue);
        }

        // CONSMEDIA-20491: New PPID Logic
        var ppid = cookie.get('ppid')

        // if cookie doesnt exist, generate new PPID and set new cookie
        if ( !ppid || ppid.length === 0 ) {
          ppid = this.generatePPID();
          cookie.set('ppid', ppid, { expires:180 })
        }
        googletag.pubads().setPublisherProvidedId(ppid);

        // Loop through all the ads that were defined using webmd.ads.defineAd()
        // so we can gather an array of ads to refresh
        Object.keys(this.ads).forEach((id) => {

          let pos, slot, adSettings, element;

          adSettings = this.ads[id];
          slot = adSettings.slot;
          pos = adSettings.pos;
          element = document.querySelector('#' + slot.getSlotElementId());

          if (element && element.classList.contains('interscroller')) {
            return true;
          }

          // Check if we should refresh only certain ad positions
          // Note: you cannot use both settings.pos and settings.id
          if (typeof settings.pos !== 'undefined') {

            // Check of the pos values were provided as an object or a single pos
            if (typeof settings.pos === 'object' && settings.pos.constructor === Object) {

              // It is an object, so see if the pos value of this ad is in the list
              if (settings.pos[pos] === true) {
                // Show this ad position
                this.slots.push(slot);
              }

            } else {

              // settings.pos is a single ad position,
              // so only refresh that one position
              if (String(pos) === String(settings.pos)) {
                this.slots.push(slot);
              }
            }

            // Check if we should refresh only certain ad ids
            // Note: you cannot use both settings.pos and settings.id
          } else if (typeof settings.id !== 'undefined') {

            // Check of the pos values were provided as an object or a single pos
            if (typeof settings.id === 'object' && settings.id.constructor === Object) {

              // It is an object, so see if the pos value of this ad is in the list
              if (settings.id[id] === true) {
                // Show this ad position
                this.slots.push(slot);
              }

            } else {

              // settings.id is a single ad id,
              // so only refresh that one ad
              if (String(id) === String(settings.id)) {
                this.slots.push(slot);
              }
            }

          } else {

            // There was not a list of ads to refresh, so we will
            // refresh each ad unless it was defined as a non-refreshable ad,
            // and unless it was listed in the posSkip parameter.

            // If this ad was defined with refresh:false then it should not be refreshed.
            // Refer to defineAd() for more info.
            if (adSettings.refresh === false) {
              // Move on to the next ad in the list
              return true;
            }

            // If this ad pos is in the settings.posSkip list then it should not be refreshed
            if (typeof settings.posSkip !== 'undefined') {

              // Check of the posSkip values were provided as an object or a single pos
              if (typeof settings.posSkip === 'object' && settings.posSkip.constructor === Object) {

                if (settings.posSkip[pos] === true) {
                  // Skip this ad position
                  return true;
                }

              } else {

                // settings.posSkip is a single ad position so only skip that one position
                if (String(pos) === String(settings.posSkip)) {
                  // Skip this ad position
                  return true;
                }
              }
            }

            // If this ad id is in the settings.idSkip list then it should not be refreshed
            if (typeof settings.idSkip !== 'undefined') {

              // Check of the idSkip values were provided as an object or a single id
              if (typeof settings.idSkip === 'object' && settings.idSkip.constructor === Object) {

                if (settings.idSkip[id] === true) {
                  // Skip this ad
                  return true;
                }

              } else {

                // settings.idSkip is a single ad id so only skip that one ad
                if (String(id) === String(settings.idSkip)) {
                  // Skip this ad
                  return true;
                }
              }
            }
            // If we get here, then the ad should not be skipped,
            // so add it to the list of ads to be refreshed
            this.slots.push(slot);
          }
        });

        // trigger 'before_adrefresh' event
        document.dispatchEvent(new CustomEvent('before_adrefresh'));

        // PPE-56979: Blank ads on Slideshows, monographs, & quizzes
        // from Google DoubleClick Publisher:
        // Our best bet is to use the GPT clear() function googletag.pubads().clear() in the ad tags before the refresh() function.
        // This will clear the object values of the ad slot where the creative is intended to render before auto-refreshing the slot.
        if (this.slots.length > 0) {
          googletag.pubads().clear(this.slots);

          if(window.semiTransparent && window.semiTransparent.includes(window.s_topic)) {
            // masking the "url" parameter to only be the hostname-no subdomians
            googletag.pubads().set("page_url", window.location.protocol + '//www.' + getSLD());
          }
          else {
            // pass the full url
            googletag.pubads().set("page_url", window.location.href);
          }
          /**
          * Double Verify Unity Tag Implementation 
          */
          var tempSlots = this.slots;
          this.onDvtagReady(function() {
            googletag.pubads().refresh(tempSlots);
          });

          // remove displayblock class for 2025 ad
          this.slots.forEach(function (slot) {
            if (slot.getSlotElementId().indexOf('2025') > -1) {
              var ele = document.querySelector('.ad-2025');
              ele.classList.remove('displayblock');
            }

            if (slot.getSlotElementId().indexOf('101') > -1) {
              let marqueeUnitStyles = document.getElementById('ad-pos-101-1-marquee-unit-style');
              if (marqueeUnitStyles) {
                marqueeUnitStyles.parentNode.removeChild(marqueeUnitStyles);
              }

              // Remove the min-width set manually on the unit to match the sub nav width
              let parentDiv = document.getElementById("ad-pos-101-1");
              if (parentDiv) {
                const firstChildDiv = parentDiv.querySelector('div');
                if (firstChildDiv) {
                  firstChildDiv.style.minWidth = "unset";
                }
              }
            }
          })

        } else {
           debug('There are no valid slots to refresh');
        }



        // trigger refreshAds event
        document.dispatchEvent(new CustomEvent('refreshAds', {
          detail: settings
        }));
      };


      //if display was called before this,
      //fire invokeRefreshLogic
      if (this.displayCalled) {
        debug('invoking refresh not using event');
        if (typeof window.tpsvc !== 'undefined') {
          //to set the refresh setting for magnite prebid function 
          this.thirdPartyCallFromRefresh=true;
          document.dispatchEvent(new CustomEvent('refreshForMagnite', {
            detail: settings
          }));
          // execute 3rd party ad services
          this.callThirdPartyAdServices(invokeRefreshLogic);
        } else {
          invokeRefreshLogic();
        }
      }

      //otherwise, wait for DFP_DISPLAY_CALLED and then
      //fire invokeRefreshLogic
      else {
        document.addEventListener('DFP_DISPLAY_CALLED', () => {
          debug('invoking refresh using event');

          fn = () => {
            //using setTimeout to skip curerent frame before invoking
            setTimeout(invokeRefreshLogic, 1);
          };

          if (typeof window.tpsvc !== 'undefined') {
              //to set the refresh setting for magnite prebid function 
              this.thirdPartyCallFromRefresh=true;
            document.dispatchEvent(new CustomEvent('refreshForMagnite', {
              detail: settings
            }));
            // execute 3rd party ad services
            this.callThirdPartyAdServices(fn);
          } else {
            fn();
          }
        });
      }

      // refresh function called
        this.refreshCalled = true;

      // Allow this function to be chained
      return this;
    },
    /**
     * Destroy some or all ads slots on the page. The ads must have been created with a call to webmd.ads.defineAd()
     *
     * @param Array [ads] The array containing IDs of ad slots to destroy.
     * Array is optional; all ad slots will be destroyed if it is unspecified.
     *
     * @returns Boolean: true if ad slots have been successfully destroyed, false otherwise.
     *
     * @example
     * // destroy specific ads
     * webmd.ads.destroy(['top-ad', 'right-rail-ad'])
     *
     * @example
     * // destroy all ads
     * webmd.ads.destroy()
     */
    destroy: function(ids) {
      let slots = [];
      let self = this;

      if (Array.isArray(ids)) {

        // gather up all the slots we want to destroy
        ids.forEach(function(id) {
          if (id in self.ads) {
            slots.push(self.ads[id].slot);
          }
        });

        if (googletag.destroySlots(slots)) {
          // if we have successfully removed slot objects from GPT,
          // free the memory associated with the destroyed slots in webmd.ads2.ads collection
          ids.forEach(function(id) {
            if (id in self.ads) {
              delete self.ads[id];

              //Removing interscroller class from ad slots on destroying it
              var element = document.querySelector('#' + id);
              if (element) {
                element.classList.remove('interscroller');
              }

              // remove display block class for pos-2025
              if (element && id.indexOf('2025') > -1) {
                element.classList.remove('displayblock');
              }

              debug('destroyed ad: ', id);
            }

          });

          document.dispatchEvent(new CustomEvent('destroyAdsComplete'));
          return true;
        }

      } else {
        if (googletag.destroySlots()) {
          // if we have successfully removed all slot objects from GPT,
          // reset webmd.ads2.ads collection. Memory will be freed during garbage collection.
          this.ads = {};

          //Removing interscroller class from all the ad slots on destroying it
          var els = document.querySelectorAll('.interscroller');
          for (var i = 0; i < els.length; i++) {
            els[i].classList.remove('interscroller')
          }

          // remove display block class for pos-2025 on destroying it
          var ele = document.querySelector('.ad-2025');
          if (ele) {
            ele.classList.remove('displayblock');
          }

          document.dispatchEvent(new CustomEvent('destroyAdsComplete'));
          debug('destroyed all ads');

          return true;
        }
      }

      return false;
    },

    /**
     * Disables the initial fetch of ads from Google when the page is first loaded.
     * Calls to refresh() can be used later to display the ads.
     * This must be called before display() is called so it can block the initial load.
     */
    disableInitialLoad: function() {

      this.googleDefer( () => {
        googletag.pubads().disableInitialLoad();
      });

      this.initialLoadDisabled = true;

      // Allow this function to be chained
      return this;
    },
    /**
     * Helper function to set the appropriate Google NetworkCode based on environment and lifecycle.
     * Logic:
     * Production Live - live network code
     * Production Preview/Staging - sandbox network code
     * Lower QA environments (QA02/PERF, QA01, QA00) - sandbox network code
     */
    setNetworkCode: function() {
      let network = {
          'live': '4312434',
          'sandbox': '8668145'
      },
      env = getEnv() || '';

      // checking for the vitals domain and
      // if the environent is qa then return the network code that we are setting for staging
      if(window.s_pagename && window.s_pagename.indexOf('vitals.') > -1 && env==='.qa'){
        return network.live;
      }

      // checking for the care domain and
      // if the environent is qa then return the network code that we are setting for staging
      if(window.s_pagename && window.s_pagename.indexOf('doctor.') > -1 && env==='.qa'){
        return network.live;
      }

      // if env is production (or functions errored), there will be no value.
      // other lower envs return values (eg: .qa00).
      if (env === '') {
        return network.live;
      }

      return network.sandbox;
    },
    /**
     * Helper function to generate a new PPID when visitor is missing or has expired PPID
     */
    generatePPID: function () {
      // params for generating PPID
      let value = '';
      let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let min = 42, max = 139;
      let length = Math.floor(Math.random() * (max - min + 1) + min);

      for (let i = length; i > 0; --i) {
         value += chars[Math.floor(Math.random() * chars.length)];
      }

      let timestamp = Math.round(Date.now()/1000);

      return `${value}-${timestamp}`;
    },
    /**
     * Double Verify Unity Tag Implementation 
     */
    onDvtagReady: function (callback, timeout) {
      var opt = { callback: callback, timestamp: new Date().getTime(), timeout: timeout }
      window.dvtag = window.dvtag || {}
      window.dvtag.cmd = window.dvtag.cmd || []
      window.dvtag.cmd.push(function () { window.dvtag.queueAdRequest(opt) })
      setTimeout(function () {
        var cb = opt.callback
        opt.callback = null
        if (cb) cb()
      }, timeout)
    }

  };

  // expose ads object in the browser
  window.webmd = window.webmd || {};
  window.webmd.ads = ads;
  ads.init();

}

export default ads;
